import styled from '@emotion/styled';

export const StyledText = styled('div')`
  color: #5B636C;
  font-family: Poppins, serif;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
`;
